// extracted by mini-css-extract-plugin
export var calendar = "index-module--calendar--ebc7f";
export var calendarDay = "index-module--calendarDay--c80e5";
export var calendarInline = "index-module--calendarInline--9b8c9";
export var calendarMonth = "index-module--calendarMonth--a53dc";
export var table = "index-module--table--252c8";
export var tableWrapper = "index-module--tableWrapper--8cae0";